import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { noop } from 'lodash/fp';

import Box from './Box';
import cn from './styles.local.less';

const parseValue = (value) => parseInt(value, 10);

const isMinValueValid = ({ min, max } = {}) => min <= max;
const isMaxValueValid = ({ min, max } = {}) => (max === 0 ? false : max >= min);

export default class PriceInputRange extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    emptyValue: PropTypes.object.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onChangeComplete: PropTypes.func,
  };

  static defaultProps = {
    onBlur: noop,
  };

  handleMinChange = (val) => {
    const { onChange, onChangeComplete, value } = this.props;
    const minValue = parseValue(val);
    const valueToSet = { min: minValue, max: value.max };

    if (isMinValueValid(valueToSet)) {
      onChange(valueToSet);
      onChangeComplete();
    }
  };

  handleMaxChange = (val) => {
    const { onChange, onChangeComplete, value } = this.props;
    const maxValue = parseValue(val);
    const valueToSet = { min: value.min, max: maxValue };

    if (isMaxValueValid(valueToSet)) {
      onChange(valueToSet);
      onChangeComplete();
    }
  };

  handleMinBlur = (val) => {
    const { onBlur, onChangeComplete, value } = this.props;
    const minValue = parseValue(val);

    if (minValue !== value.min) {
      if (minValue > value.max) {
        onBlur(value, onChangeComplete);
      } else {
        onBlur({ ...value, min: minValue }, onChangeComplete);
      }
    }
  };

  handleMaxBlur = (val) => {
    const { onChangeComplete, onBlur, value } = this.props;
    const maxValue = parseValue(val);

    if (val !== value.max) {
      if (maxValue < value.min || maxValue === 0) {
        onBlur(value, onChangeComplete);
      } else {
        onBlur({ ...value, max: maxValue }, onChangeComplete);
      }
    }
  };

  render() {
    const { emptyValue, name, value } = this.props;

    return (
      <div className={cns('row', cn.root)}>
        <div className={cns('col-xs-6', cn.fieldCol)}>
          <div className={cn.label}>{__('search.filters.inputRangeFrom')}</div>
          <Box
            defaultValue={emptyValue.min}
            value={value.min}
            qaSelector={`input-range-${name}-min`}
            onChange={this.handleMinChange}
            onBlur={this.handleMinBlur}
          />
        </div>
        <div className={cns('col-xs-6', cn.fieldCol)}>
          <div className={cn.label}>{__('search.filters.inputRangeTo')}</div>
          <Box
            defaultValue={emptyValue.max}
            value={value.max}
            qaSelector={`input-range-${name}-max`}
            onChange={this.handleMaxChange}
            onBlur={this.handleMaxBlur}
          />
        </div>
      </div>
    );
  }
}
